import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LoadState } from '@app/main/analytics/loader-directive/loader.module';
import { fuseAnimations } from '@fuse/animations';
import { Course, UserType } from '@shared/models';
import { GoogleChartInterface } from 'ng2-google-charts';
import { AnalyticsService, getDefaultDateRange } from '@shared/services/analytics.service';
import { saveAs } from 'file-saver';
import { toSnakeCase } from '@shared/utils/string.utils';

@Component({
  selector: 'program-reporting-sessions',
  templateUrl: './program-reporting-sessions.component.html',
  styleUrls: ['./program-reporting-sessions.component.scss'],
  animations: fuseAnimations
})
export class ProgramReportingSessionsComponent implements OnInit {
  @Input() course: Course;
  @Output() onOpenSessionLog = new EventEmitter<{ sessionId: string, userName: string, course: Course }>();
  @Input() selectedUserType: UserType;
  @Output() onUserTypeChange = new EventEmitter<UserType>();
  public trafficChart: GoogleChartInterface;
  public trafficDataStatus = LoadState.pending;
  private dateTo: Date;
  private dateFrom: Date;

  constructor(private _analyticsService: AnalyticsService) {}

  ngOnInit(): void {
    const defaultRange = getDefaultDateRange();
    this.dateFrom = defaultRange.date_from;
    this.dateTo = defaultRange.date_to;
    this.initCharts();
  }
  
  initCharts() {
    this.updateTrafficChart();
  }

  async updateTrafficChart(): Promise<void> {
    this.trafficDataStatus = LoadState.loading;
    try {
      const stats = await this._analyticsService.getCourseTraffic(this.course.id, { dateFrom: this.dateFrom, dateTo: this.dateTo }).toPromise();

      if (!stats || stats.length === 0) {
        this.trafficDataStatus = LoadState.empty;
        return;
      }
      this.trafficDataStatus = LoadState.completed;
      const data = [[{ type: 'date' }, '']];
      stats.map((stat: any) => {
        data.push([new Date(stat.model), stat.count]);
      });

      const dateFormat = stats.length > 31 ? 'MMM' : 'MMM dd';
      this.trafficChart = {
        chartType: 'AreaChart',
        dataTable: data,
        options: {
          legend: { position: 'none' },
          colors: ['#45a6b9'],
          height: 156,
          chartArea: { width: '100%' },
          hAxis: {
            format: dateFormat
          }
        }
      };
    } catch (e) {
      this.trafficDataStatus = LoadState.error;
    }
  }
  
  displayLogs(event: any) {
    this.onOpenSessionLog.emit({...event, course: this.course});
  }

  exportLogs(event: any) {
    this._analyticsService.getSessionLog(event.sessionId, 'csv').subscribe((data) => {
      const fileName = `Wonda_export_${toSnakeCase(this.course.title)}_session_${event.sessionId}_${new Date().toISOString().split('T')[0]}`;
      const blob = new Blob([data], { type: 'text/csv' });
      saveAs(blob, fileName);
    });
  }
}
